import React, { Component } from 'react'
import sha256 from 'js-sha256'
import axios from 'axios'
import LoadingSpinner from './Spinner'
import OverlayLoader from '../modalPopups/overlayLoader'

export default class MaropostSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            maropostData: [],
            maropostTags: [],
            maropostLists: [],
            isLoading: false,
            loadingText: '',
            maropostContactFields: ["email", "contact_id", "first_name", "last_name", "created_at", "sign", "birthcountry", "birthcity", "birthtime", "date_of_birth", "last_signup_date", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "gclsrc", "dclid", "fbclid", "fe_tpg_main_last_signup", "msclkid", "ho_click_id", "fe_tpg_has_visited", "funnel_prefix", "fe_tpg_main_utm_source", "fe_tpg_main_utm_campaign", "fe_tpg_main_utm_medium", "fe_tpg_main_utm_content", "fe_tpg_main_utm_term", "fe_tpg_main_msclkid", "fe_tpg_main_fbclid", "fe_tpg_main_dclid", "fe_tpg_main_gclsrc", "fe_tpg_main_gclid", "fe_tpg_trip_utm_source", "fe_tpg_trip_utm_campaign", "fe_tpg_trip_utm_medium", "fe_tpg_trip_utm_content", "fe_tpg_trip_utm_term", "fe_tpg_trip_msclkid", "fe_tpg_trip_fbclid", "fe_tpg_trip_dclid", "fe_tpg_trip_gclsrc", "fe_tpg_trip_gclid", "fe_tpg_main_has_visited", "visitor_variant", "phone", "approved_sms_messaging", "email_hash", "fe_tpg_short_code"],
            hash: sha256(this.props.searchterm),
            accessToken: localStorage.getItem("accessToken"),
            overLayPopupShow: false,
            overLayPopupText: ''
        }
    }

    handleOverylayModalShowClose = (modalStatus,modalText) => {
        this.setState(
            {
                overLayPopupShow: modalStatus,
                overLayPopupText: modalText
            }
        )
    }

    // Call Members Product Permissions
    fetchMaropostDetails = (URl) => {
        axios.get(URl, {				
        headers: {
            'Authorization': `Bearer ${this.state.accessToken}`
        },
        })
        .then(result => {
            this.setState({isLoading : false})
            this.handleOverylayModalShowClose(false,'')
            if(result.status === 200)
            {
                this.setState({maropostData : result.data.response})
                this.setState({maropostTags : result.data.response.tags})
                this.setState({maropostLists : result.data.response.list_subscriptions})
            }
        })
        .catch((error) => {
            // Error
            this.handleOverylayModalShowClose(false,'')
            if(error.response.status === 401)
			{
				localStorage.clear()
                this.props.navigate("/login")
			}
        });
    }

    componentDidMount() {
        this.setState({isLoading : true})
        this.setState({loadingText : 'Fetching Maropost Details'})
        this.handleOverylayModalShowClose(true,'Maropost Data Loading... Please Wait')
        this.fetchMaropostDetails(`${process.env.REACT_APP_CSAPI_BASE_URL}/maropost/contact?hash=${this.state.hash}`);
    }

  render() {
    return (
        <div className="app-wrapper">
            <div className="app-content pt-3 p-md-3 p-lg-4">
                <div className="container-xl">
                    <OverlayLoader 
                        show={this.state.overLayPopupShow}
                        title=''
                        body={this.state.overLayPopupText} 
                    />
                    <div className="app-content pt-3 mb-5">
                        {this.props.searchterm ? (
                            <h3>
                                Search: <code>{this.props.searchterm}</code>
                            </h3>
                        ) : (
                            <h3>There is no name in the query string</h3>
                        )}                
                    </div>
                    <div className="col-auto">
                        <h1 className="app-page-title mb-0">Maropost</h1>
                        <hr className="mb-4" />
                    </div>

                    {this.state.isLoading ? <LoadingSpinner loadingText={this.state.loadingText} /> : ''}

                    <div className="row mb-5">
                        <div className="col">
                        
                            <div className="card shadow">
                                <div className="rounded-top">
                                    <div className="d-grid ">
                                        <span className="bg-light border border-secondary rounded-0 rounded-top p-1 pt-2 px-3"><h4 className="text-dark">Maropost Contact Profile</h4></span>
                                    </div>
                                </div>
                                <div className="card-body overflow-auto" style={{ maxHeight:300}}>                                    
                                    {
                                        !this.state.isLoading && this.state.maropostContactFields.map((mcf, i) => {
                                            return (
                                                <div className="contact-row text-dark" key={i}>
                                                    <p><span className='me-3'>{mcf}</span><br /><span className='me-3 fw-bold'>{this.state.maropostData[mcf]}</span></p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-5">
                        <div className="col">
                        
                            <div className="card shadow">
                                <div className="rounded-top">
                                    <div className="d-grid ">
                                        <span className="bg-light border border-secondary rounded-0 rounded-top p-1 pt-2 px-3"><h4 className="text-dark">Tags</h4></span>
                                    </div>
                                </div>
                                <div className="card-body" style={{ minHeight:160}}>
                                    {
                                        this.state.maropostTags ? this.state.maropostTags.map((mct, i) => {
                                            return (
                                                <span key={i} className="badge rounded-pill border fw-normal fs-6 ms-2 py-3 mt-3 bg-secondary text-white">
                                                    {mct.name}
                                                </span>
                                            )
                                        })
                                    : null}
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card shadow">
                                <div className="rounded-top">
                                    <div className="d-grid ">
                                        <span className="bg-light border border-secondary rounded-0 rounded-top p-1 pt-2 px-3"><h4 className="text-dark">Lists</h4></span>
                                    </div>
                                </div>
                                <div className="card-body" style={{ minHeight:160}}>

                                    {
                                        this.state.maropostLists ? this.state.maropostLists
                                            .filter(mcl => mcl.status === "Subscribed")
                                            .map((mcl, i) => {
                                                return (
                                                    <span key={i} className="badge rounded-pill border fw-normal fs-6 ms-2 py-3 mt-3 bg-secondary text-white">
                                                        {mcl.name}
                                                    </span>
                                                )                                                
                                            
                                        })
                                    : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>     
            </div>
        </div>
    )
  }
}
